$(".services__cropper--logistic").hover(function () {
    $(this).closest(".section__gradient").toggleClass("pink");
    $('.services__logo--logistic').toggleClass("active");
    $('.services__category').toggleClass("active");
    $('.js-service-background[data-service="logistics"]').toggleClass("active");
    $('.js-service-content-logistics').toggleClass("active");
});

$(".services__cropper--express-fresh").hover(function () {
    $(this).closest(".section__gradient").toggleClass("green");
    $('.services__logo--fresh-express').toggleClass("active");
    $('.services__category').toggleClass("active");
    $('.js-service-background[data-service="express-fresh"]').toggleClass("active");
    $('.js-service-content-express-fresh').toggleClass("active");
});

$(".services__cropper--express").hover(function () {
    $(this).closest(".section__gradient").toggleClass("blue");
    $('.services__logo--express').toggleClass("active");
    $('.services__category').toggleClass("active");
    $('.js-service-background[data-service="express"]').toggleClass("active");
    $('.js-service-content-express').toggleClass("active");
});

$(".services__cropper--usa").hover(function () {
    $(this).closest(".section__gradient").toggleClass("red");
    $('.services__logo--usa').toggleClass("active");
    $('.services__category').toggleClass("active");
    $('.js-service-background[data-service="transport"]').toggleClass("active");
    $('.js-service-content-transport-usa').toggleClass("active");
});

$(document).ready(function() {
    $('.tabs__nav-item:first').addClass('active');
    $('.tabs__content-item:first').addClass('active');
})

$('.tabs__nav .tabs__nav-item').on('click', function(e) {
    e.preventDefault();
    var i = $(this).index();

    $('.tabs__nav .tabs__nav-item').removeClass('active');
    $(this).addClass('active');

    $('.tabs__content .tabs__content-item').removeClass('active');
    $('.tabs__content .tabs__content-item:eq(' + i +')').addClass('active');

})

$(document).ready(function() {
    var initialBg = $('.js-tab-bg-switcher.active').attr('data-tab-bg');
    $('.section-03-1').css('background-image', 'url('+ initialBg +')');

})

$('.js-tab-bg-switcher').on('click', function() {
    var bgSrc = $(this).attr('data-tab-bg');

    console.log(bgSrc);

    $('.section-03-1').css('background-image', 'url('+ bgSrc +')');
})

$('.js-services-mobile-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    slide: '.slider-nav__item',
    asNavFor: '.js-services-mobile-content',
    arrows: false,
    dots: false,
    rows: false,
    focusOnSelect: true,
})

$('.js-services-mobile-content').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    slide: '.slider-content__item',
    asNavFor: '.js-services-mobile-nav',
    rows: false,
    dots: false,
    prevArrow: '.js-services-mobile-prev',
    nextArrow: '.js-services-mobile-next',
    adaptiveHeight: true,
})